import {inject, Injectable} from '@angular/core';
import {AuthService} from '../../authentication/auth-service';
import {ClaimManagerBackend} from '../../environments/application-configurations';
import {environment} from '../../environments/environment';
import {ClaimFile, PresignedClaimFileUrlResponse} from '../entity/claim-file';
import {BatchUploadMetadata} from '../entity/batch-upload';

@Injectable({
  providedIn: 'root'
})
export class ClaimBatchService {
  private readonly authService: AuthService = inject(AuthService)
  private readonly backendConfig: ClaimManagerBackend = environment.claimManagerBackend

  public async getBatchUploadPresignedUrls(parameters: ClaimFile[]): Promise<PresignedClaimFileUrlResponse> {
    const url = `${this.backendConfig.baseUrl}${this.backendConfig.createBatchUploadPresignedUploadUrlsPath}`
    const headers = new Headers();
    headers.set('Authorization', `Bearer ${this.authService.getIdToken()}`);
    headers.set('Content-Type', 'application/json');

    return await fetch(
      url,
      {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(parameters)
      }
    ).then(r => r.json()) as PresignedClaimFileUrlResponse
  }

  public async getAllBatchUploads(): Promise<BatchUploadMetadata[]> {
    const url = `${this.backendConfig.baseUrl}${this.backendConfig.getAllBatchUploadsPath}`

    const headers = new Headers();
    headers.set('Authorization', `Bearer ${this.authService.getIdToken()}`);

    return await fetch(
      url,
      {
        method: 'GET',
        headers: headers
      }
    ).then(r => r.json()) as BatchUploadMetadata[]
  }
}
